import { useContext } from 'react';

import AnalyticsContext from '../context';
import { AnalyticsClient } from '../types';

export function useAnalytics(): AnalyticsClient {
	return useContext(AnalyticsContext);
}
